// extracted by mini-css-extract-plugin
export var promotionLink = "_v2-0";